import assign from '../assign/index.js'

export default function cloneObject(dirtyObject) {
  return assign({}, dirtyObject)
}



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/cloneObject/index.js
// module id = Fg9Y
// module chunks = 0